import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Modal from '@material-ui/core/Modal';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../store';

import { setPage } from '../../../store/features/moments/momentsSlice';

export default function ModalDialog(props: any) {
    const dispatch = useDispatch();
    const { words } = useAppSelector(state => state.localization);

    const createActionPage = () => {
        dispatch(
            setPage({
                name: 'createAction',
                type: '',
                id: '',
                managerDefinedSpecialDateId: props.momentId,
                userSpecialDateMainId: null,
            }),
        );
    };

    const homePage = () => {
        dispatch(
            setPage({
                name: 'momentsHome',
            }),
        );
    };

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className="modal-01"
            open={props.open}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
           >
            <Fade in={props.open}>
                <div className="modal-content">
                    <svg className="icon" width="102" height="103" viewBox="0 0 102 103" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M51 94C74.4727 94 93.5 74.9727 93.5 51.5C93.5 28.0273 74.4727 9 51 9C27.5273 9 8.5 28.0273 8.5 51.5C8.5 74.9727 27.5273 94 51 94Z"
                            stroke="#00A3FF"
                            strokeWidth="5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path d="M38.25 51.5L46.75 60L63.75 43" stroke="#00A3FF" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>

                    <p className="title" id="transition-modal-description">
                        {props.message}
                    </p>
                    <div className='button-wrapper'>
                        <button className="button" type="button" onClick={homePage}>
                        {words && words['WEB.backToHome']}
                        </button>
                        <button className="button" type="button" onClick={createActionPage}>
                        {words && words['WEB.ok']}
                        </button>
                    </div>
                </div>
            </Fade>
        </Modal>
    );
}
